/**
 * Header wordmark — aligns with logo gradient (indigo → violet). No teal.
 */

export const BRAND_WORDMARK_VORA = {
  as: 'span',
  fontWeight: '600',
  color: '#111827',
};

/** Gradient “Kit”; solid indigo where background-clip:text is unavailable. */
export const BRAND_WORDMARK_KIT_SX = {
  fontWeight: '700',
  display: 'inline-block',
  backgroundImage: 'linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  color: 'transparent',
  '@supports not ((-webkit-background-clip: text) or (background-clip: text))': {
    backgroundImage: 'none',
    WebkitTextFillColor: 'unset',
    color: '#6366f1',
  },
};
